import Vue from 'vue'

Vue.filter('formatCurrency', value => {

    if (!value || value == 0) return '£0'
    if (value < 100) return value.toString() + 'p'
    return '£' + (value / 100).toString()

})